module.exports = __webpack_public_path__ + "img/anonymous-avatar.2c605b65.png";